export default __webpack_public_path__ + "static/main_mobile_reversed-48919a05fd0344967827afd8d8b2a9e8.mp4";